import { ExpectedError } from '@adornis/validation/errors/ExpectedError.js';

export class RegistrationWrongCodeError extends ExpectedError {
  static override _class = 'RegistrationWrongCodeError';

  public constructor(message: string) {
    super('RegistrationWrongCodeError: ' + message, { translationKey: 'REGISTRATION_WRONG_CODE_ERROR' });
  }
}
